firebird.directive('verticalAlign', [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(
                    function () {
                        return element.outerHeight();
                    },
                    function (newHeight, oldHeight) {
                        //Prevent issue where re-positioning element changes
                        //height by 1px and causes infinite loop
                        if (Math.abs(newHeight - oldHeight) === 1) {
                            return;
                        }

                        var elementHeight = element.outerHeight();
                        var topOffset = -1 * (elementHeight / 2);

                        //Placed in empty timeout to avoid angular digest errors
                        //Anything in timeout will run at end of digest cycle
                        $timeout(function () {
                            element.css('margin-top', topOffset + 'px');
                            element.css('top', '50%');
                        });
                    }
                );
            }
        };
    }
]);
